import { useWsmDealerCustomerListQuery, useWsmDealerGroupDetailsQuery } from "@dashboard/graphql";
import useLocalPaginator, { useLocalPaginationState } from "@dashboard/hooks/useLocalPaginator";
import { mapEdgesToItems } from "@dashboard/utils/maps";
import React, { useState } from "react";
import { useLocation } from "react-router";

import WsmDealerCustomerListPage from "../components/WsmDealerCustomerListPage/WsmDealerCustomerListPage";
import { getGroupLabel } from "../utils";

const PAGINATE_BY = 20;

export const WsmDealerCustomerListView = () => {
  const location = useLocation();
  // One group's rail links here with ?group=<id>. Any other arrival has none.
  const groupId = new URLSearchParams(location.search).get("group");
  const [query, setQuery] = useState("");
  const [rowNumber, setRowNumber] = useState(PAGINATE_BY);
  const [paginationState, setPaginationState] = useLocalPaginationState(rowNumber);
  const paginate = useLocalPaginator(setPaginationState);
  const { data, loading } = useWsmDealerCustomerListQuery({
    variables: {
      ...paginationState,
      filter: {
        ...(query ? { search: query } : {}),
        ...(groupId ? { group: groupId } : {}),
      },
    },
  });
  const { data: groupData } = useWsmDealerGroupDetailsQuery({
    variables: { id: groupId ?? "" },
    skip: !groupId,
  });
  const { loadNextPage, loadPreviousPage, pageInfo } = paginate(
    data?.wsmDealerCustomers?.pageInfo,
    paginationState,
  );

  return (
    <WsmDealerCustomerListPage
      customers={loading ? undefined : (mapEdgesToItems(data?.wsmDealerCustomers) ?? [])}
      query={query}
      settings={{ rowNumber }}
      groupLabel={groupData?.wsmDealerGroup ? getGroupLabel(groupData.wsmDealerGroup) : null}
      hasNextPage={pageInfo?.hasNextPage ?? false}
      hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      onQueryChange={value => {
        setQuery(value);
        setPaginationState({});
      }}
      onUpdateListSettings={(_key, value) => setRowNumber(Number(value))}
      onNextPage={loadNextPage}
      onPreviousPage={loadPreviousPage}
    />
  );
};

export default WsmDealerCustomerListView;
